import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const AuthLayout = () => {
  const location = useLocation();
  const autheticated = isAuthenticated();
  // If already logged in, block access to auth routes
  if (autheticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default AuthLayout;